<template>
    <div>
        <main class="main-content">
            <div class="page-content">
                <div class="container-xl">
                    <div class="lds-ring" v-if="!isLoad">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <section class="domestics" v-if="isLoad">
                        <div class="page-title">
                            <h2>Domestic Flights</h2>
                            <div class="page-title__side"></div>
                            <div class="page-title__side">
                                <button class="btn btn--green" :disabled="!seasons.length" @click="add = true"><span>Add Flight</span>
                                </button>
                                <label class="btn btn--green" @click="importXLS = true">
                                    <span>Import from XLS</span></label></div>
                        </div>
                        <div class="domestics__filters">
                            <div class="domestics__filters__section">
                                <div class="domestics__filters__section__col">
                                    <div :class="['form-control-group']"><span class="form-control-label">Company</span>
                                        <div :class="['select-wrapper', { 'is-active' : selects.companyFilter }]"
                                             @click="changeSelects('companyFilter');">
                                            <div class="select-trigger"><span
                                                class="select-trigger__name">{{
                                                    companiesFilter.find(item => item.active) ? companiesFilter.find(item => item.active).name : ''
                                                }}</span><span
                                                class="select-trigger__icon">
                            <svg width="1em" height="1em" class="icon icon-chevron ">
                              <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                            </svg></span></div>
                                            <div class="select-body">
                                                <div class="select-inner js-scrollbar">
                                                    <div
                                                        v-for="item in companiesFilter"
                                                        :key="item.id"
                                                        :class="['select-option', { 'is-selected' : item.active }]"
                                                        @click="companiesFilter = companiesFilter.map(company => item.id === company.id ? {...company, active : true} : {...company, active: false})">
                                                        <span class="select-option__name">{{ item.name }}</span></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="domestics__filters__section__col">
                                    <div class="form-select-group">
                                        <div :class="['form-control-group']"><span
                                            class="form-control-label">Origin</span>
                                            <div :class="['select-wrapper', { 'is-active' : selects.originFilter }]"
                                                 @click="changeSelects('originFilter')">
                                                <div class="select-trigger">
                          <span class="select-trigger__name"
                                ref="originSelectInput"
                                contenteditable="true"
                                @input="checkSelectEdit($event)"
                          >
                            {{ originsFilter.find(item => item.active) ? originsFilter.find(item => item.active).names.EN : '' }}
                          </span>
                                                    <span class="select-trigger__icon">
                            <svg width="1em" height="1em" class="icon icon-chevron ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                            </svg>
                          </span>
                                                </div>
                                                <div class="select-body">
                                                    <div class="select-inner js-scrollbar">
                                                        <div
                                                            v-for="item in filteredOrigins"
                                                            :key="item.id + Math.random()"
                                                            :class="['select-option', { 'is-selected' : item.active }]"
                                                            @click="originsFilter = originsFilter.map(point => item.id === point.id ? {...point, active : true} : {...point, active: false});$refs.originSelectInput.textContent = item.names.EN;selectsActive.origin = item">
                                                            <span class="select-option__name">{{ item.names.EN }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-select-group__divider">
                                            <svg width="1em" height="1em" class="icon icon-arrow ">
                                                <use
                                                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-arrow"></use>
                                            </svg>
                                        </div>
                                        <div :class="['form-control-group', { 'is-error' : errors.destination }]"><span
                                            class="form-control-label">Destination</span>
                                            <div
                                                :class="['select-wrapper', { 'is-active' : selects.destinationFilter }]"
                                                @click="changeSelects('destinationFilter');">
                                                <div class="select-trigger"><span
                                                    class="select-trigger__name"
                                                    ref="destinationSelectInput"
                                                    contenteditable="true"
                                                    @input="checkSelectEdit($event)"
                                                >
                          {{
                                                        destinationsFilter.find(item => item.active) ? destinationsFilter.find(item => item.active).names.EN : ''
                                                    }}
                        </span>
                                                    <span
                                                        class="select-trigger__icon">
								<svg width="1em" height="1em" class="icon icon-chevron ">
								<use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
								</svg></span></div>
                                                <div class="select-body">
                                                    <div class="select-inner js-scrollbar">
                                                        <div
                                                            v-for="item in filteredDestinations"
                                                            :key="item.id + Math.random()"
                                                            :class="['select-option', { 'is-selected' : item.active }]"
                                                            @click="destinationsFilter = destinationsFilter.map(point => item.id === point.id ? {...point, active : true} : {...point, active: false});$refs.destinationSelectInput.textContent = item.names.EN;selectsActive.destination = item">
                                                            <span class="select-option__name">{{ item.names.EN }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="domestics__filters__section__col">
                                    <button type="button" class="btn btn--green" @click="searchFlight">
                                        <svg width="1em" height="1em" class="icon icon-search ">
                                            <use
                                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-search"></use>
                                        </svg>
                                        <span>Search</span>
                                    </button>
                                </div>
                            </div>
                            <div class="domestics__filters__section" v-if="isSearchResults">
                                <div class="domestics__filters__side"><span
                                    class="domestics__filters__side__title">Search Results:</span><span
                                    class="domestics__filters__side__text">{{ domestic.length }} Flights Found</span>
                                </div>
                                <div class="domestics__filters__side">
                                    <button type="button" class="btn btn--silver" @click="clearSearchFlight">
                                        <span>Clear</span></button>
                                </div>
                            </div>
                            <div class="domestics__filters__section"
                                 v-if="domestic.filter(item => item.selected).length">
                                <div class="domestics__filters__side"><span
                                    class="domestics__filters__side__title">{{
                                        domestic.filter(item => item.selected).length
                                    }} flights selected</span>
                                </div>
                                <div class="domestics__filters__side">
                                    <button type="button" class="btn btn--green btn--action"
                                            @click="domestic.filter(item => item.selected).length ? edit = true : false">
                                        <svg width="1em" height="1em" class="icon icon-edit ">
                                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-edit"></use>
                                        </svg>
                                        <span>Edit</span>
                                    </button>
                                    <button type="button" class="btn btn--silver" @click="$emit('deleteModalHandler', {
						entity: 'Flights',
						name: 'this',
						handler: deleteFlightsHandler,
						id: null
					})"><span>Delete</span></button>
                                </div>
                            </div>
                        </div>

                        <form action="javascript:void(0)" class="calculation-settings__box domestics-chose-seasons">
                            <div class="calculation-settings__box__header">
                                <div class="form-control-group"><span class="form-control-label">Choose Season</span>
                                    <div
                                        :class="['select-wrapper', 'select-wrapper--xl', { 'is-active' : selects.season }]"
                                        @click="changeSelects('season')"
                                        :style="{opacity: seasons.length ? 1 : .6, cursor: seasons.length ? 'pointer' : 'default', pointerEvents: seasons.length ? 'auto' : 'none'}">
                                        <div class="select-trigger"><span class="select-trigger__name"><b
                                            v-if="seasons.length">{{ seasons.find(item => item.active).name }}</b> <i
                                            v-if="seasons.length">{{
                                                seasons.find(item => item.active).dateFrom
                                            }} - {{ seasons.find(item => item.active).dateTo }}</i></span><span
                                            class="select-trigger__icon">
							<svg width="1em" height="1em" class="icon icon-chevron ">
							<use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
							</svg></span></div>
                                        <div class="select-body">
                                            <div class="select-inner">
                                                <div
                                                    v-for="item in seasons"
                                                    :key="item.id"
                                                    :class="['select-option', {'is-selected' : item.id === seasons.find(item => item.active).id}]"
                                                    @click="seasons = seasons.map(season => item.id === season.id ? {...season, active: true} : {...season, active: false})"
                                                ><span
                                                    class="select-option__name"><b>{{
                                                        item.name
                                                    }}</b> <i>{{ item.dateFrom }} - {{
                                                        item.dateTo
                                                    }}</i></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <button type="button" data-popover="Copy rates from another season"
                                        :disabled="!seasons.length"
                                        class="btn btn--green btn--sm-squared btn--popover" @click="copy = true">
                                    <svg width="1em" height="1em" class="icon icon-copy ">
                                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-copy"></use>
                                    </svg>
                                </button>
                                <a href="javascript:void(0)" class="btn btn--green btn_seasons"
                                   @click="isOpenSeasons = true">
                                    <svg width="1em" height="1em" class="icon icon-list ">
                                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-list"></use>
                                    </svg>
                                    <span>Seasons</span></a>
                            </div>

                        </form>


                        <div class="domestics__table">
                            <!-- <div data-simplebar="data-simplebar" class="section-table-wrap"> -->
                            <simplebar data-simplebar-auto-hide="true" class="section-table-wrap">
                                <table class="domestics__table__inner">
                                    <thead>
                                    <tr>
                                        <th class="domestics__table__checkbox"
                                            @click="checkFlight('all', !(domestic.filter(item => item.selected).length === domestic.length))">
                                            <label for="chk_1" class="form-control-checkbox" @click.prevent>
                                                <input id="chk_1" type="checkbox"
                                                       :checked="domestic.filter(item => item.selected).length === domestic.length"/><span
                                                class="form-control-checkbox__box">
                              <svg width="1em" height="1em" class="icon icon-check ">
                                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use>
                              </svg></span>
                                            </label>
                                        </th>
                                        <th class="domestics__table__company"><span>Company</span></th>
                                        <th class="domestics__table__origin"><span>Origin</span></th>
                                        <th class="domestics__table__destination"><span>Destination</span></th>
                                        <th class="domestics__table__frequency"><span>Frequency</span></th>
                                        <th class="domestics__table__dept"><span>Dept</span></th>
                                        <th class="domestics__table__arr"><span>Arr</span></th>
                                        <th class="domestics__table__comments"><span>Comments</span></th>
                                        <th class="domestics__table__person"><span>Adult <br/> 15 kg</span></th>
                                        <th class="domestics__table__person"><span>Child <br/> 15 kg</span></th>
                                        <th class="domestics__table__person"><span>Adult <br/> 30 kg</span></th>
                                        <th class="domestics__table__person"><span>Child <br/> 30 kg</span></th>
                                        <th class="domestics__table__pax"><span>Min Pax</span></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr
                                        v-for="(item, index) in domestic"
                                        :key="index"
                                        :class="[{ 'is-checked' : item.selected }]"
                                    >
                                        <td class="domestics__table__checkbox">
                                            <label for="chk12" class="form-control-checkbox"
                                                   @click.prevent="checkFlight(index)">
                                                <input type="checkbox" id="chk12" :checked="item.selected"/><span
                                                class="form-control-checkbox__box">
                                <svg width="1em" height="1em" class="icon icon-check ">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use>
                                </svg></span>
                                            </label>
                                        </td>
                                        <td class="domestics__table__company"><span>{{
                                                companiesFilter.find(company => company.id === item.companyId).name
                                            }}</span></td>
                                        <td class="domestics__table__origin"><span>{{
                                                originsFilter.find(company => company.id === item.origin).names.EN
                                            }}</span></td>
                                        <td class="domestics__table__destination">
                                            {{
                                                destinationsFilter.find(company => company.id === item.destination).names.EN
                                            }}
                                            <!-- <input type="text" v-model="item.destination"/> -->
                                        </td>
                                        <td class="domestics__table__frequency">
                                            <span>{{
                                                    item.frequency.length === 7 ? 'Daily' : item.frequency.join(' ')
                                                }}</span></td>
                                        <td class="domestics__table__dept">
                      <span>{{
                              item.departureTime.substring(0, 2)
                          }}:{{ item.departureTime.substring(item.departureTime.length - 2) }}</span>
                                        </td>
                                        <td class="domestics__table__arr">
                      <span>{{
                              item.arrivalTime.substring(0, 2)
                          }}:{{ item.arrivalTime.substring(item.arrivalTime.length - 2) }}</span>
                                        </td>
                                        <td class="domestics__table__comments">
                                            <p>{{ item.comments }}</p>
                                        </td>
                                        <td class="domestics__table__person"><span>{{ item.adult15 }}</span></td>
                                        <td class="domestics__table__person"><span>{{ item.child15 }}</span></td>
                                        <td class="domestics__table__person"><span>{{ item.adult30 }}</span></td>
                                        <td class="domestics__table__person"><span>{{ item.child30 }}</span></td>
                                        <td class="domestics__table__pax"><span>{{ item.minPax }}</span></td>
                                    </tr>
                                    </tbody>
                                </table>
                            </simplebar>
                        </div>
                    </section>
                </div>
            </div>
        </main>
        <div class="modal-wrapper" v-if="add || edit">
            <div class="modal-backdrop"></div>
            <div class="modal-inner">
                <div class="edit-popup edit-popup--edit-flight">
                    <div class="edit-popup__header">
                        <div class="edit-popup__title">
                            <div class="edit-popup__title__icon">
                                <svg width="1em" height="1em" class="icon icon-edit ">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-edit"></use>
                                </svg>
                            </div>
                            <span>{{
                                    add ? 'Add Flight' : `Edit ${domestic.filter(item => item.selected).length} Flights`
                                }}</span>
                        </div>
                        <div class="edit-popup__close" @click="isEdit ? $emit('notLeavePopupHandler', {
                            handler: clearEdit
                        }) : add ? add = false : edit = false">
                            <svg width="1em" height="1em" class="icon icon-close ">
                                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                            </svg>
                        </div>
                    </div>
                    <div class="edit-popup__subtitle">
                        <p>Bulk edits allows you to apply same value to multiple records</p>
                    </div>
                    <form action="javascript:void(0)" class="edit-popup__form">
                        <div class="edit-popup__form__col">
                            <div :class="['form-control-group', { 'is-error' : errors.company }]"><span
                                class="form-control-label">Company</span>
                                <div :class="['select-wrapper', { 'is-active' : selects.airline }]"
                                     @click="changeSelects('airline'); errors.company = false">
                                    <div class="select-trigger"><span
                                        class="select-trigger__name">{{ addFlight.airlines.find(item => item.active) ? addFlight.airlines.find(item => item.active).name : '' }}</span><span
                                        class="select-trigger__icon">
                            <svg width="1em" height="1em" class="icon icon-chevron ">
                              <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                            </svg></span></div>
                                    <div class="select-body">
                                        <div class="select-inner js-scrollbar">
                                            <div
                                                v-for="item in addFlight.airlines"
                                                :key="item.id"
                                                :class="['select-option', { 'is-selected' : item.active }]"
                                                @click="addFlight.airlines = addFlight.airlines.map(company => item.id === company.id ? {...company, active : true} : {...company, active: false});isEdit = true">
                                                <span class="select-option__name">{{ item.name }}</span></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="edit-popup__form__col">
                            <div :class="['form-control-group', { 'is-error' : errors.origin }]"><span
                                class="form-control-label">Origin</span>
                                <div :class="['select-wrapper', { 'is-active' : selects.departure }]"
                                     @click="changeSelects('departure'); errors.origin = false">
                                    <div class="select-trigger"><span
                                        class="select-trigger__name">{{
                                            addFlight.departure.find(item => item.active) ? addFlight.departure.find(item => item.active).names.EN : ''
                                        }}</span><span
                                        class="select-trigger__icon">
                            <svg width="1em" height="1em" class="icon icon-chevron ">
                              <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                            </svg></span></div>
                                    <div class="select-body">
                                        <div class="select-inner js-scrollbar">
                                            <div
                                                v-for="item in addFlight.departure"
                                                :key="item.id + Math.random()"
                                                :class="['select-option', { 'is-selected' : item.active }]"
                                                @click="addFlight.departure = addFlight.departure.map(point => item.id === point.id ? {...point, active : true} : {...point, active: false});isEdit = true">
                                                <span class="select-option__name">{{ item.names.EN }}</span></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="edit-popup__form__col">
                            <div :class="['form-control-group', { 'is-error' : errors.destination }]"><span
                                class="form-control-label">Destination</span>
                                <div :class="['select-wrapper', { 'is-active' : selects.arrival }]"
                                     @click="changeSelects('arrival'); errors.destination = false">
                                    <div class="select-trigger"><span
                                        class="select-trigger__name">{{
                                            addFlight.arrival.find(item => item.active) ? addFlight.arrival.find(item => item.active).names.EN : ''
                                        }}</span><span
                                        class="select-trigger__icon">
                            <svg width="1em" height="1em" class="icon icon-chevron ">
                              <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                            </svg></span></div>
                                    <div class="select-body">
                                        <div class="select-inner js-scrollbar">
                                            <div
                                                v-for="item in addFlight.arrival"
                                                :key="item.id + Math.random()"
                                                :class="['select-option', { 'is-selected' : item.active }]"
                                                @click="addFlight.arrival = addFlight.arrival.map(point => item.id === point.id ? {...point, active : true} : {...point, active: false});isEdit = true">
                                                <span class="select-option__name">{{ item.names.EN }}</span></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="edit-popup__form__col">
                            <div :class="['form-control-group', { 'is-error' : errors.freuq }]"><span
                                class="form-control-label">Frequency</span>
                                <div :class="['select-wrapper', { 'is-active' : selects.week }]"
                                     @click="changeSelects('week'); errors.freuq = false">
                                    <div class="select-trigger"><span
                                        class="select-trigger__name">{{
                                            addFlight.days.filter(item => item.active).map(item => item.name).join(', ')
                                        }}</span><span
                                        class="select-trigger__icon">
                            <svg width="1em" height="1em" class="icon icon-chevron ">
                              <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                            </svg></span></div>
                                    <div class="select-body">
                                        <div class="select-inner js-scrollbar">
                                            <div class="select-option">
                                                <label class="form-control-checkbox form-control-checkbox-add-flight"
                                                       @click.prevent.stop="addFlight.days = addFlight.days.map(item => ({...item, active: !(addFlight.days.filter(item => item.active).length === 7)}));isEdit = true">
                                                    <input type="checkbox"
                                                           :checked="addFlight.days.filter(item => item.active).length === 7"><span
                                                    class="form-control-checkbox__box">
                                  <svg width="1em" height="1em" class="icon icon-check ">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use>
                                  </svg></span><span class="select-option__name">Daily</span>
                                                </label>
                                            </div>
                                            <div
                                                v-for="item in addFlight.days"
                                                :key="item.name"
                                                :class="['select-option', { 'is-selected' : item.active }]">
                                                <label class="form-control-checkbox form-control-checkbox-add-flight"
                                                       @click.prevent.stop="item.active = !item.active;isEdit = true">
                                                    <input type="checkbox" :checked="item.active"
                                                           @click.prevent.stop><span
                                                    class="form-control-checkbox__box">
                                  <svg width="1em" height="1em" class="icon icon-check ">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use>
                                  </svg></span><span class="select-option__name">{{ item.name }}</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="edit-popup__form__col">
                            <div class="form-control-group"><span class="form-control-label">Departure</span>
                                <div :class="['form-control-wrap', { 'is-error' : errors.dep }]"
                                     @click="errors.dep = false;isEdit = true">
                                    <the-mask type="text" v-model="addFlight.timeFrom"
                                              class="form-control form-control-time"
                                              :mask="'##:##'"
                                              @input="addFlight.timeFrom = +addFlight.timeFrom.slice(0, 2) > 23 ? 23 : addFlight.timeFrom;addFlight.timeFrom.length === 4 ? addFlight.timeFrom = +addFlight.timeFrom.slice(2, 5) > 59 ? addFlight.timeFrom.slice(0, 2) + '59' : addFlight.timeFrom : false "
                                              placeholder="--:--"/>
                                </div>
                            </div>
                        </div>
                        <div class="edit-popup__form__col">
                            <div class="form-control-group"><span class="form-control-label">Arrival</span>
                                <div :class="['form-control-wrap', { 'is-error' : errors.arrival }]"
                                     @click="errors.arrival = false;isEdit = true">
                                    <the-mask type="text" v-model="addFlight.timeTo"
                                              @input="addFlight.timeTo = +addFlight.timeTo.slice(0, 2) > 23 ? 23 : addFlight.timeTo;addFlight.timeTo.length === 4 ? addFlight.timeTo = +addFlight.timeTo.slice(2, 5) > 59 ? addFlight.timeTo.slice(0, 2) + '59' : addFlight.timeTo : false "
                                              class="form-control form-control-time" :mask="'##:##'"
                                              placeholder="--:--"/>
                                </div>
                            </div>
                        </div>
                        <div class="edit-popup__form__col">
                            <div class="form-control-group form-control-group--xl"><span
                                class="form-control-label">Comments</span>
                                <div :class="['form-control-wrap', { 'is-error' : errors.comments }]">
                                    <input type="text" placeholder="Comment" @change="isEdit = true"
                                           @focus="errors.comments = false"
                                           v-model="addFlight.comment" class="form-control">
                                </div>
                            </div>
                        </div>
                        <div class="edit-popup__form__col">
                            <div class="form-control-group form-control-group--sm"><span class="form-control-label">Adult
                        15kg</span>
                                <div :class="['form-control-wrap', { 'is-error' : errors.adult15 }]">
                                    <input type="number" placeholder="0" @change="isEdit = true"
                                           v-model="addFlight.adult15"
                                           @focus="errors.adult15 = false" class="form-control">
                                </div>
                            </div>
                        </div>
                        <div class="edit-popup__form__col">
                            <div class="form-control-group form-control-group--sm"><span class="form-control-label">Child
                        15kg</span>
                                <div :class="['form-control-wrap', { 'is-error' : errors.child15 }]">
                                    <input type="number" placeholder="0" @change="isEdit = true"
                                           v-model="addFlight.child15"
                                           @focus="errors.child15 = false" class="form-control">
                                </div>
                            </div>
                        </div>
                        <div class="edit-popup__form__col">
                            <label for="chk_available" class="form-control-checkbox"
                                   @click.prevent.stop="addFlight.avail30 = !addFlight.avail30;addFlight.adult30 = !addFlight.avail30 ? '' : addFlight.adult30;addFlight.child30 = !addFlight.avail30 ? '' : addFlight.child30;isEdit = true">
                                <input id="chk_available" type="checkbox" @click.prevent
                                       :checked="addFlight.avail30"><span
                                class="form-control-checkbox__box">
                        <svg width="1em" height="1em" class="icon icon-check ">
                          <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use>
                        </svg></span><span class="form-control-checkbox__name">30kg available</span>
                            </label>
                        </div>
                        <div class="edit-popup__form__col">
                            <div class="form-control-group form-control-group--sm"><span class="form-control-label">Adult
                        30kg</span>
                                <div :class="['form-control-wrap', { 'is-error' : errors.adult30 }]">
                                    <input type="number" @change="isEdit = true" :disabled="!addFlight.avail30"
                                           placeholder="0"
                                           @focus="errors.adult30 = false" v-model="addFlight.adult30"
                                           class="form-control">
                                </div>
                            </div>
                        </div>
                        <div class="edit-popup__form__col">
                            <div class="form-control-group form-control-group--sm"><span class="form-control-label">Child
                        30kg</span>
                                <div :class="['form-control-wrap', { 'is-error' : errors.child30 }]">
                                    <input type="number" @change="isEdit = true" :disabled="!addFlight.avail30"
                                           placeholder="0"
                                           @focus="errors.child30 = false" v-model="addFlight.child30"
                                           class="form-control">
                                </div>
                            </div>
                        </div>
                        <div class="edit-popup__form__col">
                            <div class="form-control-group form-control-group--xs"><span class="form-control-label">Min
                        Pax</span>
                                <div :class="['form-control-wrap', { 'is-error' : errors.min }]">
                                    <input type="number" @change="isEdit = true" placeholder="0"
                                           v-model="addFlight.minpax"
                                           @focus="errors.min = false" class="form-control">
                                </div>
                            </div>
                        </div>
                    </form>
                    <div class="edit-popup__form-submit">
                        <button type="submit" class="btn btn--green edit-popup__submit"
                                @click="add ? createFlightHandler() : updateFlightsHandler()">
                            <span>{{ add ? 'Add Flight' : 'Apply' }}</span></button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-wrapper"
             :style="{opacity: importXLS ? 1 : 0, visibility: importXLS ? 'visible' : 'hidden', zIndex: importXLS ? 10 : '-1'}">
            <div class="modal-backdrop"></div>
            <div class="modal-inner">
                <div class="edit-popup edit-popup--import">
                    <div class="edit-popup__header">
                        <div class="edit-popup__title"><span>Import from XLS</span></div>
                        <div class="edit-popup__close" @click="importXLS = false">
                            <svg width="1em" height="1em" class="icon icon-close ">
                                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                            </svg>
                        </div>
                    </div>
                    <form action="javascript:void(0)" class="edit-popup--import__form">
                        <div class="edit-popup--import__form__side">
                            <div class="form-upload-group"><span class="form-upload-group__title">Upload a file</span>
                                <div class="form-upload-group__inner">
                                    <label for="fileInput" class="form-upload-group__label">
                                        <input id="fileInput" ref="xlsFile" type="file" @change="toUpload($event)"><span
                                        class="btn btn--green btn--shadowed"><span>Choose a
                              file</span></span>
                                    </label>
                                    <div class="form-upload-group__item" v-if="isFileToImport"><span
                                        title="filename.xls"
                                        class="form-upload-group__item__name">{{
                                            isFileToImport.name
                                        }}</span>
                                        <button type="button" class="btn btn--remove" @click="isFileToImport = null">
                                            <svg width="1em" height="1em" class="icon icon-close ">
                                                <use
                                                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="edit-popup--import__submit" v-if="isFileToImport">
                            <button type="submit" class="btn btn--green" @click="xls(isFileToImport)">
                                <div class="lds-ellipsis" v-if="fileUploaded">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </div>
                                <span v-else>Import</span></button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <Seasons @notLeavePopupHandler="data => $emit('notLeavePopupHandler', data)" @errored="$emit('errored')"
                 @deleteModalHandler="data => $emit('deleteModalHandler', data)" :open="isOpenSeasons"
                 @confirmed="$emit('confirmed')" :title="'Flights'" @close="closeSeasons" :type="'flight'" :user="user"
                 :companies="companiesFilter"/>
        <div class="modal-wrapper" v-if="copy">
            <div class="modal-backdrop"></div>
            <div class="modal-inner">
                <div class="edit-popup edit-popup--copy-season">
                    <div class="edit-popup__header">
                        <div class="edit-popup__title">
                            <div class="edit-popup__title__icon">
                                <svg width="1em" height="1em" class="icon icon-copy ">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-copy"></use>
                                </svg>
                            </div>
                            <span>Copy rates</span>
                        </div>
                        <div class="edit-popup__close" @click="copy = false">
                            <svg width="1em" height="1em" class="icon icon-close ">
                                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                            </svg>
                        </div>
                    </div>
                    <form action="javascript:void(0)" class="edit-popup__inner">
                        <div class="edit-popup__info">
                            <p>{{ seasons.find(item => item.active).name }}
                                <i>{{ seasons.find(item => item.active).dateFrom }} -
                                    {{ seasons.find(item => item.active).dateTo }}</i></p>
                        </div>
                        <div class="edit-popup__side-wrap">
                            <div class="edit-popup__side">
                                <div class="form-control-group"><span
                                    class="form-control-label form-control-label-bold">Prices for the <b
                                    :style="{display: 'inline-block'}">"{{
                                        seasons.find(item => item.active).name
                                    }}"</b> season will be copied from the season:</span>
                                    <div
                                        :class="['select-wrapper', 'select-wrapper--xl', { 'is-active' : selects.seasonCopy }]"
                                        @click="changeSelects('seasonCopy')">
                                        <div class="select-trigger"><span
                                            class="select-trigger__name"><b>{{
                                                copySeasons.find(item => item.active).name
                                            }}</b> <i>{{
                                                copySeasons.find(item => item.active).dateFrom
                                            }} - {{ copySeasons.find(item => item.active).dateTo }}</i></span><span
                                            class="select-trigger__icon">
                                    <svg width="1em" height="1em" class="icon icon-chevron ">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                    </svg></span></div>
                                        <div class="select-body">
                                            <div class="select-inner">
                                                <div
                                                    v-for="item in copySeasons"
                                                    :key="item.id"
                                                    :class="['select-option', {'is-selected' : item.id === copySeasons.find(item => item.active).id}]"
                                                    @click="copySeasons = copySeasons.map(season => item.id === season.id ? {...season, active: true} : {...season, active: false})"
                                                ><span
                                                    class="select-option__name"><b>{{
                                                        item.name
                                                    }}</b> <i>{{ item.dateFrom }} - {{
                                                        item.dateTo
                                                    }}</i></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <button type="submit" class="btn btn--green edit-popup__submit" @click="copySeasonsHandler">
                                <svg width="1em" height="1em" class="icon icon-copy ">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-copy"></use>
                                </svg>
                                <span>Copy</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {
    getFlights,
    deleteFlights,
    getPointsAll,
    getAirlinesAll,
    createFlight,
    updateFlights,
    getSeasonsType,
    copyFlightSeasons,
    updateFlightsCosts,
    getFlight,
    getAirstripsAll
} from '@/utilites/api'

import XLSX from 'xlsx'

import simplebar from 'simplebar-vue';
import Lightpick from 'lightpick'
import {TheMask} from 'vue-the-mask'

import Seasons from '@/components/Seasons'
import ClipboardJS from 'clipboard'

export default {
    props: ['user'],
    components: {simplebar, Lightpick, TheMask, Seasons, ClipboardJS},
    data() {
        return {
            domestic: [],
            domesticData: [],
            search: {
                company: '',
                from: '',
                to: '',
            },
            seasons: [],
            isSearchResults: false,
            copySeasons: [],
            copy: false,
            add: false,
            edit: false,
            importXLS: false,
            isFileToImport: null,
            isOpenSeasons: false,
            fileUploaded: false,
            addFlight: {
                departure: [],
                arrival: [],
                airlines: [],
                days: [
                    {
                        name: 'Monday',
                        active: false,
                        id: 0
                    },
                    {
                        name: 'Tuesday',
                        active: false,
                        id: 1
                    },
                    {
                        name: 'Wednesday',
                        active: false,
                        id: 2
                    },
                    {
                        name: 'Thursday',
                        active: false,
                        id: 3
                    },
                    {
                        name: 'Friday',
                        active: false,
                        id: 4
                    },
                    {
                        name: 'Saturday',
                        active: false,
                        id: 5
                    },
                    {
                        name: 'Sunday',
                        active: false,
                        id: 6
                    }
                ],
                timeFrom: '',
                timeTo: '',
                comment: '',
                adult15: '',
                child15: '',
                adult30: '',
                child30: '',
                avail30: true,
                minpax: ''
            },
            companiesFilter: [],
            originsFilter: [],
            destinationsFilter: [],
            selects: {
                departure: false,
                arrival: false,
                airline: false,
                week: false,
                season: false,
                seasonCopy: false,
                companyFilter: false,
                originFilter: false,
                destinationFilter: false
            },
            isLoad: false,
            isEdit: false,
            errors: {
                company: false,
                origin: false,
                destination: false,
                freuq: false,
                dep: false,
                arrival: false,
                comments: false,
                adult15: false,
                child15: false,
                adult30: false,
                child30: false,
                min: false
            },
            selectInputSearch: '',
            selectsActive: {
                origin: {
                    names: {EN: ''}
                },
                destination: {
                    names: {EN: ''}
                },
            },
        }
    },
    beforeCreate() {
        document.title = 'Domestic Flights'
    },
    mounted() {
        getAirstripsAll().then(res => {
          // console.log('getAirstripsAll res', res)
          this.originsFilter = res.map(item => ({
                ...item.airstrip,
                active: false
            })).sort((a, b) => a.names.EN > b.names.EN ? 1 : -1)

            this.destinationsFilter = res.map(item => ({
                ...item.airstrip,
                active: false
            })).sort((a, b) => a.names.EN > b.names.EN ? 1 : -1)

            this.addFlight.departure = res.map(item => ({
                ...item.airstrip,
                active: false
            })).sort((a, b) => a.names.EN > b.names.EN ? 1 : -1)

            this.addFlight.arrival = res.map(item => ({
                ...item.airstrip,
                active: false
            })).sort((a, b) => a.names.EN > b.names.EN ? 1 : -1)
        })
        // getPointsAll()
        //   .then(res => {
        //     let airports = res.filter(item => item.type === 'AIRPORT')
        //     let airstrips = res.filter(item => item.type === 'AIRSTRIP')
        //     this.addFlight.departure = airports.sort((a, b) => a.title > b.title ? 1 : -1).concat(airstrips.sort((a, b) => a.title > b.title ? 1 : -1)).map((item) => ({
        //       ...item,
        //       active: false
        //     }))
        //     this.addFlight.arrival = airports.sort((a, b) => a.title > b.title ? 1 : -1).concat(airstrips.sort((a, b) => a.title > b.title ? 1 : -1)).map((item) => ({
        //       ...item,
        //       active: false
        //     }))
        //     this.originsFilter = airports.sort((a, b) => a.title > b.title ? 1 : -1).concat(airstrips.sort((a, b) => a.title > b.title ? 1 : -1)).map((item) => ({
        //       ...item,
        //       active: false
        //     }))
        //     this.destinationsFilter = airports.sort((a, b) => a.title > b.title ? 1 : -1).concat(airstrips.sort((a, b) => a.title > b.title ? 1 : -1)).map((item) => ({
        //       ...item,
        //       active: false
        //     }))
        //   })
        getAirlinesAll(this.user.access_token)
            .then(res => {
              // console.log('getAirlinesAll res', res)
              // console.log('getAirlinesAll this.user.access_token', this.user.access_token)

              this.addFlight.airlines = res.map((item) => ({
                    ...item,
                    active: false
                })).sort((a, b) => a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1)
                this.companiesFilter = res.map((item) => ({
                    ...item,
                    active: false
                })).sort((a, b) => a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1)
            })
        getSeasonsType(this.user.access_token, 'flight')
            .then(res => {
                this.seasons = res.map((item, index) => index === 0 ? {...item, active: true} : {
                    ...item,
                    active: false
                })
                this.copySeasons = res.map((item, index) => index === 0 ? {...item, active: true} : {
                    ...item,
                    active: false
                })
            })
        window.addEventListener('click', event => {
            if (!event.target.closest('.select-wrapper')) {
                this.selects = {
                    departure: false,
                    arrival: false,
                    airline: false,
                    week: false,
                    season: false,
                    seasonCopy: false,
                    companyFilter: false,
                    originFilter: false,
                    destinationFilter: false
                }
            }
        })
        window.addEventListener('click', event => {
            if (!event.target.closest('.edit-popup') && !event.target.closest('.btn')) {
                this.copy = false
                this.importXLS = null
                if (this.isEdit) {
                    // this.$emit('notLeavePopupHandler', {
                    //   handler: this.clearEdit
                    // })
                } else {
                    this.add = false
                    this.edit = false
                }
            }
        })
    },
    computed: {
        filteredOrigins() {
            return this.originsFilter.filter(point => point.names.EN.toLowerCase().includes(this.selectInputSearch.toLowerCase()))
        },
        filteredDestinations() {
            return this.destinationsFilter.filter(point => point.names.EN.toLowerCase().includes(this.selectInputSearch.toLowerCase()))
        }
    },
    methods: {
        checkSelectEdit(e) {
          this.selectInputSearch = e.target.textContent
        },
        changeSelects(target) {
            this.selects = {
                departure: false,
                arrival: false,
                airline: false,
                week: false,
                season: false,
                seasonCopy: false,
                companyFilter: false,
                originFilter: false,
                destinationFilter: false,
                [target]: !this.selects[target]
            }
            this.selectInputSearch = ''
            if (target === 'originFilter') {
                if (this.selects.originFilter) this.$refs.originSelectInput.focus()
                else this.$refs.originSelectInput.blur()
            }
            if (target === 'destinationFilter') {
                if (this.selects.destinationFilter) this.$refs.destinationSelectInput.focus()
                else this.$refs.destinationSelectInput.blur()
            }
        },
        checkErrors() {
            let error = false;
            this.errors = {
                company: !this.addFlight.airlines.find(item => item.active),
                origin: !this.addFlight.arrival.find(item => item.active),
                destination: !this.addFlight.departure.find(item => item.active),
                freuq: this.addFlight.days.filter(item => item.active).length === 0,
                dep: this.addFlight.timeFrom.length < 4,
                arrival: this.addFlight.timeTo.length < 4,
                comments: false,
                adult15: this.addFlight.adult15.length === 0,
                child15: this.addFlight.child15.length === 0,
                adult30: this.addFlight.avail30 && this.addFlight.adult30.length === 0,
                child30: this.addFlight.avail30 && this.addFlight.child30.length === 0,
                min: this.addFlight.minpax.length === 0
            }
            for (const key in this.errors) {
                if (this.errors[key]) {
                    error = true
                }
            }
            return error

        },
        checkFlight(id, flag) {
            if (id === 'all') {
                this.domestic = this.domestic.map(item => ({...item, selected: flag}))
            } else {
                this.domestic = this.domestic.map((item, index) => {
                    if (id === index) {
                        return {
                            ...item,
                            selected: !item.selected
                        }
                    }
                    return item
                })
            }
        },
        closeSeasons() {
            this.isOpenSeasons = false
        },
        deleteFlightsHandler() {
            deleteFlights(this.user.access_token, this.domestic.filter(item => item.selected).map(item => item.id))
                .then(res => {
                    this.domestic = this.domestic.filter(item => !item.selected)
                })
        },
        updateFlightsHandler() {
            if (this.domestic.filter(item => item.selected).length === 1 && this.checkErrors()) return false;
            let updateObject = {}
            if (this.addFlight.airlines.find(item => item.active)) {
                updateObject.companyId = this.addFlight.airlines.find(item => item.active).id
            }
            if (this.addFlight.departure.find(item => item.active)) {
                updateObject.origin = this.addFlight.departure.find(item => item.active).id
            }
            if (this.addFlight.arrival.find(item => item.active)) {
                updateObject.destination = this.addFlight.arrival.find(item => item.active).id
            }
            if (this.addFlight.days.filter(item => item.active).map(item => item.name).length > 0) {
                updateObject.frequency = this.addFlight.days.filter(item => item.active).map(item => item.name)
            }
            if (this.addFlight.timeFrom) {
                updateObject.departureTime = `${this.addFlight.timeFrom.slice(0, 2)}:${this.addFlight.timeFrom.slice(-2)}`
            }
            if (this.addFlight.timeTo) {
                updateObject.arrivalTime = `${this.addFlight.timeTo.slice(0, 2)}:${this.addFlight.timeTo.slice(-2)}`
            }
            if (this.addFlight.comment) {
                updateObject.comments = this.addFlight.comment
            }
            if (this.addFlight.adult15) {
                updateObject.adult15 = this.addFlight.adult15
            }
            if (this.addFlight.child15) {
                updateObject.child15 = this.addFlight.child15
            }
            if (this.addFlight.adult30) {
                updateObject.adult30 = this.addFlight.adult30
            }
            if (this.addFlight.child30) {
                updateObject.child30 = this.addFlight.child30
            }
            if (this.addFlight.minpax) {
                updateObject.minPax = this.addFlight.minpax
            }
            updateObject.seasonId = this.seasons.find(item => item.active).id
            updateFlights(this.user.access_token, this.domestic.filter(item => item.selected).map(item => item.id), updateObject)
                .then(() => {
                    this.updateData(this.seasons.find(item => item.active).id)
                    this.$emit('confirmed')
                    this.edit = null
                    this.isEdit = false
                })
        },
        createFlightHandler() {
            if (!this.checkErrors()) {
                createFlight(this.user.access_token, {
                    companyId: this.addFlight.airlines.find(item => item.active).id,
                    origin: this.addFlight.departure.find(item => item.active).id,
                    destination: this.addFlight.arrival.find(item => item.active).id,
                    frequency: this.addFlight.days.filter(item => item.active).map(item => item.name),
                    departureTime: `${this.addFlight.timeFrom.slice(0, 2)}:${this.addFlight.timeFrom.slice(-2)}`,
                    arrivalTime: `${this.addFlight.timeTo.slice(0, 2)}:${this.addFlight.timeTo.slice(-2)}`,
                    comments: this.addFlight.comment,
                    adult15: this.addFlight.adult15,
                    child15: this.addFlight.child15,
                    adult30: this.addFlight.adult30,
                    child30: this.addFlight.child30,
                    minPax: this.addFlight.minpax,
                    seasonId: this.seasons.find(item => item.active).id,
                })
                    .then(() => {
                        this.$emit('confirmed')
                        this.updateData(this.seasons.find(item => item.active).id)
                        this.add = false
                        this.isEdit = false
                        this.resetData()
                    })
            }
        },
        searchFlight() {
            if (this.companiesFilter.find(item => item.active) && this.originsFilter.find(item => item.active) && this.destinationsFilter.find(item => item.active)) {
                this.domestic = this.domesticData.filter(item => {
                    return item.origin === this.originsFilter.find(item => item.active).id &&
                      item.destination === this.destinationsFilter.find(item => item.active).id &&
                      item.companyId === this.companiesFilter.find(item => item.active).id;
                })
                this.isSearchResults = true
            }
        },
        clearSearchFlight() {
            this.domestic = this.domesticData
            this.isSearchResults = false
            this.companiesFilter = this.companiesFilter.map(item => ({...item, active: false}))
            this.originsFilter = this.originsFilter.map(item => ({...item, active: false}))
            this.destinationsFilter = this.destinationsFilter.map(item => ({...item, active: false}))
            this.$refs.originSelectInput.textContent = ''
            this.$refs.destinationSelectInput.textContent = ''
            this.selectsActive.origin = false
            this.selectsActive.destination = false
        },
        xls(file) {
            this.fileUploaded = true
            let selectedFile = file
            let reader = new FileReader();
            reader.addEventListener('load', (event) => this.processingXLS(event))
            reader.readAsBinaryString(selectedFile);
        },
        processingXLS(event) {
            try {
                let data = event.target.result;
                let workbook = XLSX.read(data, {
                    type: 'binary'
                });
                let json = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames.shift()], {
                    header: ["companyId", "origin", "destination", "frequency", "departureTime", "arrivalTime", "comments", "adult15", "child15", "adult30", "child30", "minPax"]
                });
                json.forEach((item, index, array) => {
                    if (index - array.length === -1) return false
                    if (array[index + 1].companyId === array[index].companyId && array[index + 1].origin === array[index].origin && array[index + 1].destination === array[index].destination && array[index + 1].departureTime === array[index].departureTime) {
                        throw new Error(`Duplicates find (line ${index + 1})`)
                    }
                })
                json = json.filter(item => this.domestic.find(dom => dom.company === item.companyId && dom.origin === item.origin && dom.destination === item.destination && dom.departureTime === item.departureTime && dom.arrivalTime === item.arrivalTime && dom.comments === item.comments && dom.adult15 === +item.adult15 && +dom.child15 === +item.child15 && +dom.adult30 === +item.adult30 && +dom.child30 === +item.child30 && +dom.minPax === +item.minPax) ? false : true)
                json = json.map((item, index, array) => {
                    if (!this.addFlight.airlines.find(airline => airline.name === item.companyId)) {
                        throw new Error(`Error.Row ${index + 1} - Missing Company`)
                    }
                    if (!this.addFlight.arrival.find(point => point.names.EN === item.origin)) {
                        throw new Error(`Error.Row ${index + 1} - Missing Airport`)

                    }
                    if (!this.addFlight.departure.find(point => point.names.EN === item.destination)) {
                        throw new Error(`Error.Row ${index + 1} - Missing Airport`)
                    }
                    return ({
                        ...item,
                        departureTime: item.departureTime.trim().length === 5 ? item.departureTime : `0${item.departureTime}`,
                        arrivalTime: item.arrivalTime.trim().length === 5 ? item.arrivalTime : `0${item.arrivalTime}`,
                        companyId: this.addFlight.airlines.find(airline => airline.name === item.companyId).id,
                        origin: this.addFlight.arrival.find(point => point.names.EN === item.origin).id,
                        destination: this.addFlight.departure.find(point => point.names.EN === item.destination).id,
                        frequency: item.frequency === 'Daily' ? this.addFlight.days.map(item => item.name) : item.frequency.split(',').map(day => day.trim()),
                        seasonId: this.seasons.find(item => item.active).id
                    })
                })
                json.forEach((item, index) => {
                    if (!item.companyId) {
                        throw new Error('Not found Company in data base (line ' + (index + 1) + ')')
                    }
                    if (!item.destination) {
                        throw new Error('Not found Destination in data base (line ' + (index + 1) + ')')
                    }
                    if (!item.origin) {
                        throw new Error('Not found Origin in data base (line ' + (index + 1) + ')')
                    }
                    if (!item.frequency) {
                        throw new Error('Not found frequency (line ' + (index + 1) + ')')
                    }
                    if (!(item.departureTime.toString().search(':') === 2 && item.departureTime.toString().trim().length === 5)) {
                        throw new Error('incorrect departure time (line ' + (index + 1) + ')')
                    }
                    if (!(item.arrivalTime.toString().search(':') === 2 && item.arrivalTime.toString().trim().length === 5)) {
                        throw new Error('incorrect arrival time (line ' + (index + 1) + ')')
                    }
                })
                json = json.filter((v, i, a) => a.findIndex(t => (t.companyId === v.companyId && t.origin === v.origin && t.destination === v.destination && t.departureTime === v.departureTime && t.arrivalTime === v.arrivalTime && t.comments === v.comments && t.adult15 === v.adult15 && t.child15 === v.child15 && t.adult30 === v.adult30 && t.child30 === v.child30 && t.minPax === v.minPax)) === i)
                if (json.length === 0) {
                    throw new Error('Not found unique values')
                }
                Promise.all(json.map(item => createFlight(this.user.access_token, item)
                    .then(() => {
                        this.importXLS = false
                        this.$emit('confirmed')
                        this.updateData(this.seasons.find(item => item.active).id)
                        this.add = false
                        this.isEdit = false
                        this.resetData()
                        this.fileUploaded = false
                        this.$refs.xlsFile.value = ''
                    })
                    .catch(() => {
                        this.fileUploaded = false
                    })
                ))
            } catch (error) {
                this.$emit('errored', {text: error.message, time: 3000})
                this.importXLS = false
                this.updateData(this.seasons.find(item => item.active).id)
                this.add = false
                this.isEdit = false
                this.resetData()
                this.fileUploaded = false
                this.$refs.xlsFile.value = ''
            }
        },
        toUpload(event) {
            let selectedFile = event.target.files[0]
            this.isFileToImport = selectedFile
        },
        copySeasonsHandler() {
            copyFlightSeasons(this.user.access_token, this.copySeasons.find(item => item.active).id, this.seasons.find(item => item.active).id)
                .then(res => {
                    this.domestic = res
                    this.domesticData = res
                    updateFlightsCosts(this.user.access_token, res.map(item => ({
                        id: item.id,
                        adult15: item.adult15,
                        child15: item.child15,
                        adult30: item.adult30,
                        child30: item.child30,
                    })), this.seasons.find(item => item.active).id)
                    this.copy = false
                })
                .catch(() => this.copy = false)
        },
        updateData(id) {
            this.isLoad = false
            getFlights(this.user.access_token, id)
                .then(res => {
                    this.domestic = res
                    this.domesticData = res
                    this.isLoad = true
                })
            document.querySelectorAll('.lightpick').forEach(elem => {
                elem.remove()
            })
            setTimeout(() => {
                document.querySelectorAll('.js-datepicker-single').forEach(item => {
                    const datePicker = new Lightpick({
                        field: item,
                        singleDate: true,
                        lang: 'en',
                        format: 'DD MMM YYYY',
                    });
                });
                document.querySelectorAll('.form-control-datepicker').forEach(function (item) {
                    const datePicker = new Lightpick({
                        field: item.children[0].querySelector('.form-control'),
                        secondField: item.children[1].querySelector('.form-control'),
                        singleDate: false,
                        lang: 'en',
                        format: 'DD MMM YYYY',
                    });
                });
            }, 500)
        },
        resetData() {
            this.addFlight.departure = this.addFlight.departure.map((item) => ({...item, active: false}))
            this.addFlight.arrival = this.addFlight.arrival.map((item) => ({...item, active: false}))
            this.addFlight.airlines = this.addFlight.airlines.map((item) => ({...item, active: false}))
            this.addFlight.days = this.addFlight.days.map(item => ({...item, active: false}))
            this.addFlight = {
                ...this.addFlight,
                timeFrom: '',
                timeTo: '',
                comment: '',
                adult15: '',
                child15: '',
                adult30: '',
                child30: '',
                avail30: true,
                minpax: ''
            }
        },
        clearEdit() {
            this.edit = null
            this.add = null
            this.isEdit = false
        }
    },
    watch: {
        add() {
            this.errors = {
                company: false,
                origin: false,
                destination: false,
                freuq: false,
                dep: false,
                arrival: false,
                comments: false,
                adult15: false,
                child15: false,
                adult30: false,
                child30: false,
                min: false
            }
            setTimeout(() => {
                document.querySelectorAll('.modal-inner .js-datepicker-single').forEach(item => {
                    const datePicker = new Lightpick({
                        field: item,
                        singleDate: true,
                        lang: 'en',
                        format: 'DD MMM YYYY',
                    });
                });
            }, 500)
            this.resetData()
        },
        edit() {
            this.errors = {
                company: false,
                origin: false,
                destination: false,
                freuq: false,
                dep: false,
                arrival: false,
                comments: false,
                adult15: false,
                child15: false,
                adult30: false,
                child30: false,
                min: false
            }
            if (this.domestic.filter(item => item.selected).length === 1) {
                getFlight(this.user.access_token, this.domestic.find(item => item.selected).id)
                    .then(res => {
                        this.addFlight.departure = this.addFlight.departure.map((item) => ({
                            ...item,
                            active: item.id === res.origin
                        }))
                        this.addFlight.arrival = this.addFlight.arrival.map((item) => ({
                            ...item,
                            active: item.id === res.destination
                        }))
                        this.addFlight.airlines = this.addFlight.airlines.map((item) => ({
                            ...item,
                            active: item.id === res.companyId
                        }))
                        this.addFlight.days = this.addFlight.days.map(item => ({
                            ...item,
                            active: res.frequency.includes(item.name)
                        }))
                        this.addFlight = {
                            ...this.addFlight,
                            timeFrom: res.departureTime,
                            timeTo: res.arrivalTime,
                            comment: res.comments,
                            adult15: this.domestic.find(item => item.selected).adult15,
                            child15: this.domestic.find(item => item.selected).child15,
                            adult30: this.domestic.find(item => item.selected).adult30,
                            child30: this.domestic.find(item => item.selected).child30,
                            avail30: true,
                            minpax: res.minPax
                        }
                    })
            }
            setTimeout(() => {
                document.querySelectorAll('.modal-inner .js-datepicker-single').forEach(item => {
                    const datePicker = new Lightpick({
                        field: item,
                        singleDate: true,
                        lang: 'en',
                        format: 'DD MMM YYYY',
                    });
                });
            }, 500)
            this.resetData()
        },
        seasons() {
            if (this.seasons.find(item => item.active)) {
                this.updateData(this.seasons.find(item => item.active).id)
            } else {
                this.isLoad = true
            }
        },
        isOpenSeasons() {
            if (!this.isOpenSeasons) {
                getSeasonsType(this.user.access_token, 'flight')
                    .then(res => {
                        this.seasons = res.map((item, index) => index === 0 ? {...item, active: true} : {
                            ...item,
                            active: false
                        })
                        this.copySeasons = res.map((item, index) => index === 0 ? {...item, active: true} : {
                            ...item,
                            active: false
                        })
                    })
            }
        },
        'selects.originFilter'(newVal) {
            if (!newVal && this.selectsActive.origin) {
                this.$refs.originSelectInput.textContent = this.selectsActive.origin.names.EN
            }
        },
        'selects.destinationFilter'(newVal) {
            if (!newVal && this.selectsActive.destination) {
                this.$refs.destinationSelectInput.textContent = this.selectsActive.destination.names.EN
            }
        },
    }
}
</script>
